/* Product-page reveal enhancements. */
(() => {
  'use strict';

  const SIZE_ORDER = ['xs', 's', 'm', 'l', 'xl', '2xl', 'xxl', '3xl', '4xl'];

  const normalizeSize = (value) => value.trim().toLowerCase().replace(/\s+/g, '');

  document.querySelectorAll('.zalvaro-size-picker').forEach((picker) => {
    const select = picker.querySelector('select');
    if (select) {
      const options = Array.from(select.options).map((option) => ({
        option,
        rank: SIZE_ORDER.indexOf(normalizeSize(option.value)),
      }));

      if (options.length && options.every(({ rank }) => rank >= 0)) {
        options
          .sort((a, b) => a.rank - b.rank)
          .forEach(({ option }) => select.append(option));
      }
    }

    const pairs = Array.from(picker.querySelectorAll('input[type="radio"]')).map((input) => ({
      input,
      label: picker.querySelector(`label[for="${CSS.escape(input.id)}"]`),
      rank: SIZE_ORDER.indexOf(normalizeSize(input.value)),
    }));

    if (!pairs.length || pairs.some(({ label, rank }) => !label || rank < 0)) return;

    pairs
      .sort((a, b) => a.rank - b.rank)
      .forEach(({ input, label }) => {
        picker.append(input, label);
      });
  });

  if (!document.documentElement.lang.toLowerCase().startsWith('en')) {
    document.querySelectorAll('.storeseo-faq__heading').forEach((heading) => {
      heading.closest('.shopify-section')?.setAttribute('hidden', '');
    });
  }

  const revealTargets = [
    '.product__info-container > *',
    '.zalvaro-tabs',
    '.product__media-item',
    '.product__description',
    '.product-form__buttons'
  ];
  const revealElements = document.querySelectorAll(revealTargets.join(', '));

  if (!revealElements.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealElements.forEach((element) => {
      element.style.opacity = '1';
      element.style.transform = 'none';
    });
    return;
  }

  revealElements.forEach((element) => {
    element.style.opacity = '0';
    element.style.transform = 'translateY(10px)';
    element.style.transition = 'opacity 400ms ease-in-out, transform 400ms ease-in-out';
    element.style.willChange = 'opacity, transform';
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        entry.target.style.removeProperty('will-change');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
  );

  revealElements.forEach((element) => observer.observe(element));
})();
